module.exports = __webpack_public_path__ + "static/pantry-peaches-c12bfd2727464de4a6cdf1aa82020638.jpg";